import './embed-mazo.css';
import CreditApplicationFormV2 from '../credit-application-form-v2/credit-application-form-v2.container';
import { LeadSource } from '../../models/application.model';

export default function EmbedMazo() {
  return (
    <div id="embed-mazo">
      <CreditApplicationFormV2 leadSource={LeadSource.EMBED_MAZO} />
    </div>
  );
}
